import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Styles from "./AppRoutes.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ProtectedRoute from "../components/ProtectedRoutes";
import axios from "axios";
import { openToastAndSetContent } from "../redux/actions/toast/toastActions";
import { useHistory } from "react-router";
import { logOut } from "../redux/actions/auth/authActions";
import { saveLoading } from "../redux/actions/loadingState/loadingStateActions";
import LoaderSpinner from "react-loader-spinner";

// without lazy loading
import ParentContainer from "../components/ParentContainer/ParentContainer";
import Drawer from "../components/drawer/Drawer";
import SignIn from "../views/SignIn/SignIn";
import AccountType from "../components/accountSetUp/AccountType";
import LoginPasswordReset from "../components/accountSetUp/LoginPasswordReset";
import EmailVerification from "../components/accountSetUp/EmailVerification";
import NewPassword from "../components/accountSetUp/NewPassword";
import ForgotPassword from "../components/emailTemplates/ForgotPassword";
import ResetCompletePassword from "../components/accountSetUp/ResetCompletePassword";
import MonitorServers from "../views/Monitor/MonitorServers";
import MonitorTransactions from "../views/Monitor/MonitorTransactions";
import AdminOverview from "../views/AdminOverview/AdminOverview";
// import Businesses from "../views/Businesses/Businesses";
const Businesses = React.lazy(() => import("../views/Businesses/Businesses"));
const TransactionManagement = React.lazy(
  () => import("../views/TransactionManagement/TransactionManagement")
);
const TransactionDetails = React.lazy(
  () => import("../views/TransactionManagement/TransactionDetails")
);
const Providers = React.lazy(() => import("../views/FeesAndLimits/Providers"));
const Approvals = React.lazy(() => import("../views/FeesAndLimits/Approvals"));
const Fees = React.lazy(() => import("../views/FeesAndLimits/Fees"));
const WalletManagement = React.lazy(
  () => import("../views/WalletManagement/WalletManagement")
);
const WalletDetails = React.lazy(
  () => import("../views/WalletManagement/WalletDetails")
);
const DebitDetails = React.lazy(
  () => import("../views/WalletManagement/DebitDetails")
);
const Settlements = React.lazy(() => import("../views/Settlement/Settlements"));
const SettlementDetails = React.lazy(
  () => import("../views/Settlement/SettlementDetails")
);
const ReviewedSettlementDetails = React.lazy(
  () => import("../views/Settlement/ReviewedSettlementsDetails")
);
const FailedSettlementDetails = React.lazy(
  () => import("../views/Settlement/FailedSettlementsDetails")
);
const ReportDetails = React.lazy(
  () => import("../views/Settlement/ReportDetails")
);

const SettlementPendingApproval = React.lazy(
  () => import("../views/Settlement/SettlementPendingApproval")
);
const Reconciliations = React.lazy(
  () => import("../views/Settlement/Reconciliations")
);
const AllCompliance = React.lazy(
  () => import("../views/Compliance/AllCompliance")
);
const Legal = React.lazy(() => import("../views/Legal/Legal"));
const POS = React.lazy(() => import("../views/PointOfSale/POS"));
const AllChargebacks = React.lazy(
  () => import("../views/ChargebackManagement/AllChargebacks")
);
const Refunds = React.lazy(
  () => import("../views/ChargebackManagement/Refunds")
);
const RefundDetails = React.lazy(
  () => import("../views/ChargebackManagement/RefundDetails")
);
const Roles = React.lazy(() => import("../views/UsersAndPermissions/Roles"));
const AuditTrail = React.lazy(
  () => import("../views/UsersAndPermissions/AuditTrail")
);
const Users = React.lazy(() => import("../views/UsersAndPermissions/Users"));
const Limits = React.lazy(() => import("../views/FeesAndLimits/Limits"));
const ComplianceDetails = React.lazy(
  () => import("../components/complianceDetails/ComplianceDetails")
);
const UploadChargeback = React.lazy(
  () => import("../views/ChargebackManagement/UploadChargeback")
);
const EmailTemplate = React.lazy(
  () => import("../components/emailTemplates/EmailTemplate")
);

const MerchantTransaction = React.lazy(
  () => import("../components/emailTemplates/MerchantTransaction")
);
const CustomerTransaction = React.lazy(
  () => import("../components/emailTemplates/CustomerTransaction")
);
const Bank = React.lazy(() => import("../views/Bank/Bank"));
const BankDetails = React.lazy(
  () => import("../components/bankDetails/BankDetails")
);
const Modules = React.lazy(
  () => import("../views/UsersAndPermissions/Modules")
);
const BusinessTab = React.lazy(
  () => import("../components/businessDetails/BusinessTab")
);
const ChargebackDetailsNew = React.lazy(
  () => import("../views/ChargebackManagement/ChargebackDetails")
);
const Account = React.lazy(() => import("../views/Account/Account"));
const Customermgt = React.lazy(() => import("../views/customer/Customermgt"));
const CustomerDetails = React.lazy(
  () => import("../views/customer/CustomerDetails")
);
const RollingReserve = React.lazy(
  () => import("../views/rollingReserve/RollingReserve")
);
const FeeCompliance = React.lazy(
  () => import("../views/Compliance/FeeCompliance")
);
const LimitCompliance = React.lazy(
  () => import("../views/Compliance/LimitCompliance")
);
const ScheduleCompliance = React.lazy(
  () => import("../views/Compliance/ScheduleCompliance")
);
const ConfigCompliance = React.lazy(
  () => import("../views/Compliance/ConfigCompliance")
);
const DueSettlements = React.lazy(
  () => import("../views/Settlement/DueSettlement")
);
import Fraudmgt from "../views/FraudRiskManagement/Fraudmgt";

import FraudDetails from "../views/FraudRiskManagement/FraudDetails";

const Hotlist = React.lazy(
  () => import("../views/FraudRiskManagement/Hotlist")
);
const Marketingmgt = React.lazy(
  () => import("../views/marketing/Marketingmgt")
);
const LogDetails = React.lazy(() => import("../views/marketing/LogDetails"));
const Payoutmgt = React.lazy(() => import("../views/payout/Payoutmgt"));
const PayoutDetails = React.lazy(() => import("../views/payout/PayoutDetails"));
const PaymentLink = React.lazy(() => import("../views/payment/PaymentLink"));
const PaymentDetails = React.lazy(
  () => import("../views/payment/PaymentDetails")
);
const MerchantInvoice = React.lazy(
  () => import("../views/payment/MerchantInvoice")
);
const InvoiceDetails = React.lazy(
  () => import("../views/payment/InvoiceDetails")
);
const CountryList = React.lazy(() => import("../views/utility/CountryList"));
const UtilityRoutes = React.lazy(() => import("../views/utility/Routes"));
const ProvidersRoutes = React.lazy(() => import("../views/utility/Providers"));
const CustomReports = React.lazy(() => import("../views/utility/CustomReport"));
const CategoryList = React.lazy(() => import("../views/utility/CategoryList"));
const WealthTab = React.lazy(() => import("../views/wealth/WealthTab"));
const WealthBalance = React.lazy(() => import("../views/wealth/WealthBalance"));
const FeeComplianceDetails = React.lazy(
  () => import("../components/complianceDetails/FeeComplianceDetails")
);
const ConfigComplianceDetails = React.lazy(
  () => import("../components/complianceDetails/ConfigComplianceDetails")
);
const UserDetailsTab = React.lazy(
  () => import("../components/usersDetails/UserDetailsTabs")
);
const ChargebackSummaryReport = React.lazy(
  () => import("../views/ChargebackManagement/ChargebackSummaryReport")
);
const ChargebackSummaryDetails= React.lazy(
  () => import("../views/ChargebackManagement/ChargebackSummaryDetails")
);
import BusinessDetails from "../components/businessDetails/BusinessDetails";
import Limit from "../components/businessDetails/Limit";
import Fee from "../components/businessDetails/Fee";
import SettlementSchedule from "../components/businessDetails/SettlementSchedule";
import Document from "../components/businessDetails/Document";
import PaymentMethodTable from "../components/businessDetails/paymentMethod/PaymentMethodTable";
import User from "../components/businessDetails/User";
import RecentSettlement from "../components/businessDetails/RecentSettlement";
import Customer from "../components/businessDetails/Customer";
import RecentTransactions from "../components/businessDetails/RecentTransactions";
import RecentRolling from "../components/businessDetails/RecentRollingReserve";
import PaymentProperty from "../components/businessDetails/PaymentProperty";
import ProcessorSettlement from "../views/Settlement/ProcessorSettlement";
import { response } from "express";
import { baseURL } from "../api";
import PaymentRoute from "../components/businessDetails/PaymentRoute";

export default function AppRoutes() {
  const dispatch = useDispatch();
  const { loadingState } = useSelector(
    (state) => state?.loadingStatePayReducer
  );

  const history = useHistory();
  const auth = useSelector((state) => state?.authPayReducer?.auth);
  const access_token = auth?.access_token;

  axios.defaults.headers.common.authorization = `Bearer ${access_token}`;
  axios.defaults.baseURL = baseURL;
  // axios.defaults.baseURL = process.env.REACT_APP_ROOT_URL;
  // axios.defaults.headers.post['Content-Type'] = 'application/json';
  // axios.defaults.headers.delete['Content-Type'] = 'application/json';
  // axios.defaults.headers.get['Content-Type'] = 'application/json';

  axios?.interceptors?.response?.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    (error) => {
      const message = error?.response?.data?.message;
      if (
        error?.response?.status === 401
        // ||message?.toLowerCase() === "login again"
      ) {
        dispatch(
          openToastAndSetContent({
            toastContent: message || "Token expired",
            toastType: "error",
          })
        );
        localStorage.clear();
        dispatch(logOut());
        dispatch(saveLoading(false));
        // history.push("/signIn");
      }
      // else if (error.response) {
      // 	dispatch(
      // 		openToastAndSetContent({
      // 			toastContent: message,
      // 		})
      // 	);
      // } else if (error.request) {
      // 	console.log("sorry, there was an error");
      // }
      else {
        return Promise.reject(error);
        // return error;
      }
      // handle expired token
    }
  );

  return (
    <Router>
      <ParentContainer>
        <Drawer />
        <div className={Styles.wrap}>
          <Suspense
            fallback={
              <div
                style={{
                  // display: "flex",
                  // alignItems: "center",
                  // justifyContent: "center",
                  // height: "100vh",
                  // width: "100vw"
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1400,
                }}
              >
                <LoaderSpinner
                  type="Puff"
                  color="#002841"
                  height="50"
                  width="50"
                  radius={1}
                  visible={true}
                />
              </div>
            }
          >
            <Switch>
              <Route exact path="/signin">
                <SignIn />
              </Route>
              <Route exact path="/account_type">
                <AccountType />
              </Route>
              <Route exact path="/forgotpassword">
                <LoginPasswordReset />
              </Route>
              <Route exact path="/newpassword">
                <NewPassword />
              </Route>
              <Route exact path="/email_verification">
                <EmailVerification />
              </Route>
              <Route exact path="/reset-password">
                <ResetCompletePassword />
              </Route>
              <Route exact path="/monitor-servers">
                <MonitorServers />
              </Route>
              <Route exact path="/monitor-transactions">
                <MonitorTransactions />
              </Route>
              <>
                <ProtectedRoute
                  exact
                  path="/"
                  component={AdminOverview}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses"
                  component={Businesses}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/info/:id"
                  component={BusinessDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/limit/:id"
                  component={Limit}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/fees/:id"
                  component={Fee}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/settlements/:id"
                  component={SettlementSchedule}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/documents/:id"
                  component={Document}
                  AuthUser={loadingState}
                />

                {/* <ProtectedRoute
									exact
									path="/businesses/payment-method/:id"
									component={PaymentMethod}
									AuthUser={loadingState}
								/> */}

                <ProtectedRoute
                  exact
                  path="/businesses/payment-method/:id"
                  component={PaymentMethodTable}
                  AuthUser={loadingState}
                />

                <ProtectedRoute
                  exact
                  path="/businesses/users/:id"
                  component={User}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/recent-settlements/:id"
                  component={RecentSettlement}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/customers/:id"
                  component={Customer}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/recent-transactions/:id"
                  component={RecentTransactions}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/rolling-reserves/:id"
                  component={RecentRolling}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/payment-property/:id"
                  component={PaymentProperty}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/businesses/payment-route/:id"
                  component={PaymentRoute}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/transactionmgt"
                  component={TransactionManagement}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/transactionmgt/details/:id"
                  component={TransactionDetails}
                  AuthUser={loadingState}
                />
                {/* <ProtectedRoute
                exact
                path="/transactionmgt/refunds"
                component={Refunds}
                AuthUser={loadingState}
              /> */}
                <ProtectedRoute
                  exact
                  path="/transactionmgt/chargebackmgt"
                  component={AllChargebacks}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/transactionmgt/chargebackmgt/summary"
                  component={ChargebackSummaryReport}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/transactionmgt/chargebackmgt/summary/:id"
                  component={ChargebackSummaryDetails}
                  AuthUser={loadingState}
                />
                {/* <ProtectedRoute
								exact
								path="/chargebackmgt"
								component={AllChargebacks}
								AuthUser={loadingState}
							/> */}
                <ProtectedRoute
                  exact
                  path="/transactionmgt/chargebackmgt/:id"
                  component={ChargebackDetailsNew}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/refunds"
                  component={Refunds}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/transactionmgt/refunds/:id"
                  component={RefundDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="transactionmgt/chargebackmgt/upload"
                  component={UploadChargeback}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/fees"
                  component={Fees}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/fees/limits"
                  component={Limits}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/fees/providers"
                  component={Providers}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/fees/approvals"
                  component={Approvals}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/walletmgt/:id"
                  component={WalletDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/walletmgt/debit/:id"
                  component={DebitDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlements"
                  component={Settlements}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlements/due"
                  component={DueSettlements}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlements/processor"
                  component={ProcessorSettlement}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlement/:id"
                  component={SettlementDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/reviewed_settlement/:id"
                  component={ReviewedSettlementDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/failed_settlement/:id"
                  component={FailedSettlementDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlement_report/:id"
                  component={ReportDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlements/reconciliation"
                  component={Reconciliations}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/settlements/pending_approval"
                  component={SettlementPendingApproval}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/walletmgt"
                  component={WalletManagement}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/pos"
                  component={POS}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance"
                  component={AllCompliance}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/fees"
                  component={FeeCompliance}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/limit"
                  component={LimitCompliance}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/schedule"
                  component={ScheduleCompliance}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/config"
                  component={ConfigCompliance}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/bank"
                  component={Bank}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/bank/:id"
                  component={BankDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/business/:id"
                  component={ComplianceDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/fee/:id"
                  component={FeeComplianceDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/compliance/config/:id"
                  component={ConfigComplianceDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/legal"
                  component={Legal}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/customermgt"
                  component={Customermgt}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/customer/:id"
                  component={CustomerDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/rollingreserve"
                  component={RollingReserve}
                  AuthUser={loadingState}
                />
                {/* <ProtectedRoute
              exact
              path="/legal/partners_banks"
              component={PartnersBanksProvider}
              AuthUser={loadingState}
            /> */}
                <ProtectedRoute
                  exact
                  path="/fraudmgt"
                  component={Fraudmgt}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/fraudmgt/:id"
                  component={FraudDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/hotlist"
                  component={Hotlist}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/marketingmgt"
                  component={Marketingmgt}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/logs/:id"
                  component={LogDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/payout"
                  component={Payoutmgt}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/payout/:id"
                  component={PayoutDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/paymentlinks"
                  component={PaymentLink}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/paymentlinks/:id"
                  component={PaymentDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/merchantinvoice"
                  component={MerchantInvoice}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/merchantinvoice/:id"
                  component={InvoiceDetails}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/usersandpermissions"
                  component={Users}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/usersandpermissions/user/:id"
                  component={UserDetailsTab}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/usersandpermissions/roles"
                  component={Roles}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/usersandpermissions/modules"
                  component={Modules}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/usersandpermissions/audittrail"
                  component={AuditTrail}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/email"
                  component={EmailTemplate}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/forgotPass"
                  component={ForgotPassword}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/customer"
                  component={CustomerTransaction}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/merchant"
                  component={MerchantTransaction}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/account"
                  component={Account}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/utility/countrylist"
                  component={CountryList}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/utility/categorylist"
                  component={CategoryList}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/utility/routes"
                  component={UtilityRoutes}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/utility/providers"
                  component={ProvidersRoutes}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/utility/custom-reports"
                  component={CustomReports}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/summary"
                  component={WealthTab}
                  AuthUser={loadingState}
                />
                <ProtectedRoute
                  exact
                  path="/wealth/balance"
                  component={WealthBalance}
                  AuthUser={loadingState}
                />
              </>
            </Switch>
          </Suspense>
        </div>
      </ParentContainer>
    </Router>
  );
}
